import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const FlagDescargaExcelFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Form.Group>
      <Col md={4} />
      <Col md={8}>
        <Field name='flagDescargaExcel'>
          {({ field }) => (
            <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagDescargaExcel' label='Descarga Excel' />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagDescargaExcelFormGroup)
